import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { Locations, LocationsEntity } from "../../../location/location";
import { LocationService } from "../../../location/location.service";
import { DesignsModel, DesignSystem, SystemDesign, SystemEntity } from "src/app/design/design.model";
import { DesignService } from "src/app/design/design.service";

@Component({
  selector: "app-confirm-location-design",
  templateUrl: "./confirm-location-design.component.html",
  styleUrls: ["./confirm-location-design.component.css"],
})
export class ConfirmLocationDesignComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = true;
  location_id:string|number;


  designId:number| string;
  location: LocationsEntity;

  constructor(
    private route: ActivatedRoute,
    private locationService:LocationService,
    private designService: DesignService,
    private snackBar: MatSnackBar
  ) {
    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams) {
        this.designId = queryParams.id
        this.location_id = queryParams.location_id
        this.getSystemByDesign(this.designId)
        this.getLocationById(this.location_id)
      }
    });
  }
  systemsDesigns: DesignsModel;


  ngOnInit() {
  }


    /**
   * Get System By Design List
   */
     getSystemByDesign(SystemDesign_id) {
      this.showLoader = true;
      this.subscription$.add(
        this.designService.getViewDesigns(SystemDesign_id).subscribe(
          (result: SystemDesign) => {
            this.systemsDesigns = result.Designs;
            this.showLoader = false;
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`Error in Getting System Design List `, "", {
              duration: 2000,
            });
          }
        )
      );
    }


      /**
   * Get Location Details By Id
   */
   getLocationById(locationId: String | number) {
    this.showLoader = true;
    this.subscription$.add(
      this.locationService
        .getSingleLocation(locationId)
        .subscribe((result: Locations) => {
          if (result?.Loc.length) {
            this.location = result?.Loc[0];
          }
          this.showLoader = false;
        },(error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Location Details. `, "", {
            duration: 2000,
          });
        })
    );
  }
/**
 * unsubscribe the subscriptions
 */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
